import ScheduledReportCreatePage from './ScheduledReportCreatePage';
import ScheduledReportEditPage from './ScheduledReportEditPage';
import AnalyticsReport from './AnalyticsReport';

export default {
  AnalyticsReport,
  ScheduledReportCreatePage,
  ScheduledReportEditPage
};
